import {NgModule} from '@angular/core';

import {MdcTabScroller} from './tab-scroller';

@NgModule({
  exports: [MdcTabScroller],
  declarations: [MdcTabScroller]
})
export class MdcTabScrollerModule { }
